import supabase from './supabase';

const SCRIPT_ID = 'aox-google-recaptcha-v3';

export const getFormTracking = (sourceLocation, sourceKey = null) => {
  const params = new URLSearchParams(window.location.search || '');
  const hash = window.location.hash || '';
  const hashQueryIndex = hash.indexOf('?');
  const hashParams = hashQueryIndex >= 0 ? new URLSearchParams(hash.slice(hashQueryIndex + 1)) : new URLSearchParams();
  const getParam = (key) => params.get(key) || hashParams.get(key) || null;
  const storedSource = sourceKey
    ? window.sessionStorage.getItem(`aox1234_form_source_${sourceKey}`)
    : null;

  return {
    source_location: storedSource || sourceLocation,
    page_url: window.location.href,
    referrer: document.referrer || null,
    utm_source: getParam('utm_source'),
    utm_medium: getParam('utm_medium'),
    utm_campaign: getParam('utm_campaign'),
  };
};

export const clearFormSource = (sourceKey) => {
  if (sourceKey) window.sessionStorage.removeItem(`aox1234_form_source_${sourceKey}`);
};

const loadRecaptcha = (siteKey) => {
  if (!siteKey) return Promise.reject(new Error('Το reCAPTCHA δεν έχει Site Key.'));
  if (window.grecaptcha) return Promise.resolve(window.grecaptcha);

  return new Promise((resolve, reject) => {
    const existing = document.getElementById(SCRIPT_ID);
    if (existing) {
      existing.addEventListener('load', () => resolve(window.grecaptcha), { once: true });
      existing.addEventListener('error', () => reject(new Error('Αποτυχία φόρτωσης reCAPTCHA.')), { once: true });
      return;
    }

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(siteKey)}`;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve(window.grecaptcha);
    script.onerror = () => reject(new Error('Αποτυχία φόρτωσης reCAPTCHA.'));
    document.head.appendChild(script);
  });
};

const getRecaptchaToken = async (siteKey, action) => {
  const grecaptcha = await loadRecaptcha(siteKey);
  return new Promise((resolve, reject) => {
    grecaptcha.ready(async () => {
      try {
        const token = await grecaptcha.execute(siteKey, { action });
        resolve(token);
      } catch (error) {
        reject(error);
      }
    });
  });
};

export const submitAoxForm = async ({ formType, payload, siteConfig, action }) => {
  let recaptchaToken = null;

  if (siteConfig?.recaptcha_enabled) {
    recaptchaToken = await getRecaptchaToken(siteConfig.recaptcha_site_key, action);
  }

  const { data, error } = await supabase.functions.invoke('aox-submit-form', {
    body: {
      form_type: formType,
      payload,
      recaptcha_token: recaptchaToken,
      recaptcha_action: action,
    },
  });

  if (error) throw error;
  if (!data?.success) {
    const code = data?.error || 'submission_failed';
    if (code === 'recaptcha_failed') throw new Error('Η επιβεβαίωση anti-spam απέτυχε. Παρακαλώ δοκιμάστε ξανά.');
    if (code === 'recaptcha_required') throw new Error('Απαιτείται επιβεβαίωση anti-spam.');
    throw new Error('Η υποβολή δεν ολοκληρώθηκε. Παρακαλώ δοκιμάστε ξανά.');
  }

  return data;
};
